import { useEffect } from "react"

/**
 * Tells the dialog whether an action's write is in flight, so it will not close under it. Reports
 * idle again when the action is disarmed.
 */
export function useReportBusy(onBusyChange: (busy: boolean) => void, busy: boolean) {
  useEffect(() => {
    onBusyChange(busy)
  }, [onBusyChange, busy])

  useEffect(() => () => onBusyChange(false), [onBusyChange])
}
